module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAAQlBMVEVMaXGwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwqwNwpryfVVAAAAFnRSTlMATtCYDbk03f9lQj0TrBx99HGPpQXouE/5ggAAAO9JREFUeAG10wWShDAUhOHGkiZue/+rbl6Nu/8lsW8UgIRhnHDevIwKhzSpcNZKLjg0kuY2sdY6IRbKHqWEeASZkRyEyOwojUHeJZJpQzQZkI7JuCG5YyEFg64IPC4Bi1ZYNmT7a0aeVNEbuCG9YlcRJy2DmXggt3qFjLfTG5Iabma2ZH5MHG42HEgrtdapYag9AydDOSOUZhQZIgKlM/JH+VKI7K0bou+QfJ0k9k7J3ymBMtbYhmCsNQHN9qUS8tKPRo69BiuDwixD/u2Pvk0efxDWnPPaoHJPYZZhfe1H43ZqQziVm/lvPQGEf9T0D6+VHZX5YpKoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/yscy/_img/yscy_a_rili.png
// module id = 8kS8
// module chunks = 2